import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useUpdatePropertyMutation } from '../store/docApi';
import { Add } from '@mui/icons-material';
import PatternCard from './PatternCard';
import { generateEntityId } from '../utils';

export default function Patterns({ item }) {
  const navigate = useNavigate();
  const [updateProperty] = useUpdatePropertyMutation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [newPattern, setNewPattern] = useState({  name: '', steps: [] });
  const [newPatternId, setNewPatternId] = useState(generateEntityId('pattern'));

  const addPattern = () => {
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: `patterns/${newPatternId}`, value: newPattern });
    setNewPattern({ name: '', steps: [] });
    setNewPatternId(generateEntityId('pattern'));
    setIsDialogOpen(false);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Patterns
      </Typography>
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))' }}>
        {item.patterns &&
          Object.entries(item.patterns).map(([id, pattern]) => (
            <PatternCard key={id} patternId={id} pattern={pattern} onClick={() => navigate(`/workspaces/${item.pk}/${item.id}/patterns/${id}`)} />
          ))}
      </Box>
      <Button variant="outlined" startIcon={<Add />} onClick={() => setIsDialogOpen(true)} sx={{ mt: 2 }}>
        Add Pattern
      </Button>
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth>
        <DialogTitle>Add New Pattern</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            ID
          </Typography>
          <TextField
            value={newPatternId}
            onChange={(e) => setNewPatternId(e.target.value)}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
          <Typography variant="body2" sx={{ mb: 1 }}>
            Name
          </Typography>
          <TextField
            value={newPattern.name}
            onChange={(e) => setNewPattern({ ...newPattern, name: e.target.value })}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={addPattern}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
